// extracted by mini-css-extract-plugin
export default {"main":"VoteDetail_main__tnb-P"};